export const VERB_DICTIONARY = [
  // A
  { verbo: "Abitare", translation: "to live", participio: "abitato", futuro: "abiter-",
    participio_options: ["abituto", "abitito", "abito"], futuro_options: ["abitr-", "abitar-", "abitir-"]},
  { verbo: "Abbassare", translation: "to lower", participio: "abbassato", futuro: "abbasser-",
    participio_options: ["abbassuto", "abbassito", "abbasso"], futuro_options: ["abbassar-", "abbassir-", "abbassr-"]},
  { verbo: "Accendere", translation: "to turn on", participio: "acceso", futuro: "accender-",
    participio_irregolare: true,
    participio_options: ["accenduto", "accendato", "accendito"],
    futuro_options: ["accendr-", "accendir-", "accendier-"]},
  { verbo: "Accettare", translation: "to accept", participio: "accettato", futuro: "accetter-",
    participio_options: ["accettuto", "accettito", "accetto"], futuro_options: ["accettar-", "accettir-", "accettr-"]},
  { verbo: "Accorgersi", translation: "to notice", participio: "accorto", futuro: "accorger-",
    participio_irregolare: true,
    participio_options: ["accorguto", "accorgito", "accorgato"],
    futuro_options: ["accorgr-", "accorgier-", "accorgerr-"]},
  { verbo: "Addormentarsi", translation: "to fall asleep", participio: "addormentato", futuro: "addormenter-",
    participio_options: ["addormentuto", "addormentito", "addormentento"], futuro_options: ["addormentar-", "addormentir-", "addormentr-"]},
  { verbo: "Affittare", translation: "to rent an apartment", participio: "affittato", futuro: "affitter-",
    participio_options: ["affittuto", "affittito", "affittoto"], futuro_options: ["affittar-", "affittir-", "affitr-"]},
  { verbo: "Agire", translation: "to act", participio: "agito", futuro: "agir-",
    participio_options: ["aguto", "agato", "agiato"], futuro_options: ["agar-", "agier-", "agr-"]},
  { verbo: "Aggiornare", translation: "to update", participio: "aggiornato", futuro: "aggiorner-",
    participio_options: ["aggiornuto", "aggiornito", "aggiorneto"], futuro_options: ["aggiornar-", "aggiornir-", "aggiornr-"]},
  { verbo: "Aggiungere", translation: "to add", participio: "aggiunto", futuro: "aggiunger-",
    participio_irregolare: true,
    participio_options: ["aggiunguto", "aggiungato", "aggiungito"],
    futuro_options: ["aggiungr-", "aggiungir-", "aggiungier-"]},
  { verbo: "Aiutare", translation: "to help", participio: "aiutato", futuro: "aiuter-",
    participio_options: ["aiututo", "aiutito", "aiutanto"], futuro_options: ["aiutar-", "aiutir-", "aiutr-"]},
  { verbo: "Allenarsi", translation: "to train", participio: "allenato", futuro: "allener-",
    participio_options: ["allenuto", "allenito", "alleneto"], futuro_options: ["allenar-", "allenir-", "allenr-"]},
  { verbo: "Alzare", translation: "to raise/to lift", participio: "alzato", futuro: "alzer-",
    participio_options: ["alzuto", "alzito", "alzeto"], futuro_options: ["alzar-", "alzir-", "alzr-"]},
  { verbo: "Alzarsi", translation: "to get up", participio: "alzato", futuro: "alzer-",
    participio_options: ["alzuto", "alzito", "alzanto"], futuro_options: ["alzar-", "alzir-", "alzr-"]},
  { verbo: "Amare", translation: "to love", participio: "amato", futuro: "amer-",
    participio_options: ["amuto", "amito", "amoto"], futuro_options: ["amar-", "amir-", "amr-"]},
  { verbo: "Ammalarsi", translation: "to get sick", participio: "ammalato", futuro: "ammaler-",
    participio_options: ["ammaluto", "ammalito", "ammaleto"], futuro_options: ["ammalar-", "ammalir-", "ammalr-"]},
  { verbo: "Annaffiare", translation: "to water", participio: "annaffiato", futuro: "annaffier-",
    participio_options: ["annaffiuto", "annaffiito", "annaffito"], futuro_options: ["annaffiar-", "annaffiir-", "annaffir-"]},
  { verbo: "Annoiarsi", translation: "to get bored", participio: "annoiato", futuro: "annoier-",
    participio_options: ["annoiuto", "annoiito", "annoieto"], futuro_options: ["annoiar-", "annoiir-", "annoir-"]},
  { verbo: "Andare", translation: "to go", participio: "andato", futuro: "andr-",
    futuro_irregolare: true,
    participio_options: ["anduto", "andito", "andeto"],
    futuro_options: ["ander-", "andar-", "andier-"]},
  { verbo: "Apparire", translation: "to appear", participio: "apparso", futuro: "apparir-",
    participio_irregolare: true,
    participio_options: ["apparuto", "apparito", "apparato"],
    futuro_options: ["apparr-", "apparer-", "apparier-"]},
  { verbo: "Appendere", translation: "to hang", participio: "appeso", futuro: "appender-",
    participio_irregolare: true,
    participio_options: ["appenduto", "appendato", "appendito"],
    futuro_options: ["appendr-", "appendir-", "appendier-"]},
  { verbo: "Apprezzare", translation: "to appreciate", participio: "apprezzato", futuro: "apprezzer-",
    participio_options: ["apprezzuto", "apprezzito", "apprezzoto"], futuro_options: ["apprezzar-", "apprezzir-", "apprezzr-"]},
  { verbo: "Aprire", translation: "to open", participio: "aperto", futuro: "aprir-",
    participio_irregolare: true,
    participio_options: ["apruto", "aprito", "aprato"],
    futuro_options: ["aprr-", "aprer-", "aprier-"]},
  { verbo: "Arrabbiarsi", translation: "to get angry", participio: "arrabbiato", futuro: "arrabbier-",
    participio_options: ["arrabbiuto", "arrabbiito", "arrabbioto"], futuro_options: ["arabbiar-", "arrabbiir-", "arabbir-"]},
  { verbo: "Arrivare", translation: "to arrive", participio: "arrivato", futuro: "arriver-",
    participio_options: ["arrivuto", "arrivito", "arrivoto"], futuro_options: ["arrivar-", "arrivir-", "arrivr-"]},
  { verbo: "Asciugare", translation: "to dry", participio: "asciugato", futuro: "asciugher-",
    participio_options: ["asciuguto", "asciugito", "asciughito"], futuro_options: ["asciugar-", "asciugir-", "asciugr-"]},
  { verbo: "Ascoltare", translation: "to listen", participio: "ascoltato", futuro: "ascolter-",
    participio_options: ["ascoltuto", "ascoltito", "ascoltoto"],
    futuro_options: ["ascoltar-", "ascoltir-", "ascoltr-"]},
  { verbo: "Aspettare", translation: "to wait", participio: "aspettato", futuro: "aspetter-",
    participio_options: ["aspettuto", "aspettito", "aspettoto"], futuro_options: ["aspettar-", "aspettir-", "aspettr-"]},
  { verbo: "Avere", translation: "to have", participio: "avuto", futuro: "avr-",
    futuro_irregolare: true,
    participio_options: ["avito", "avato", "aveva"],
    futuro_options: ["aver-", "avver-", "avìr-"]},
  { verbo: "Avvicinarsi", translation: "to get closer", participio: "avvicinato", futuro: "avviciner-",
    participio_options: ["avvicinuto", "avvicinito", "avvicinanto"], futuro_options: ["avvicinar-", "avvicinir-", "avviciner-"]},

  // B
  { verbo: "Baciare", translation: "to kiss", participio: "baciato", futuro: "bacer-",
    participio_options: ["baciuto", "baciito", "bacioto"], futuro_options: ["baciar-", "baciir-", "bacir-"]},
  { verbo: "Ballare", translation: "to dance", participio: "ballato", futuro: "baller-",
    participio_options: ["balluto", "ballito", "balloto"], futuro_options: ["ballar-", "ballir-", "ballr-"]},
  { verbo: "Bere", translation: "to drink", participio: "bevuto", futuro: "berr-",
    participio_irregolare: true, futuro_irregolare: true,
    participio_options: ["berito", "beruto", "bevato"],
    futuro_options: ["ber-", "bever-", "bevr-"]},
  { verbo: "Buttare", translation: "to throw away", participio: "buttato", futuro: "butter-",
    participio_options: ["buttuto", "buttito", "buttoto"], futuro_options: ["buttar-", "buttir-", "buttr-"]},

  // C
  { verbo: "Cadere", translation: "to fall", participio: "caduto", futuro: "cadr-",
    futuro_irregolare: true,
    participio_options: ["cadato", "cadito", "cadoto"],
    futuro_options: ["cader-", "caderr-", "cedir-"]},
  { verbo: "Cambiare", translation: "to change", participio: "cambiato", futuro: "cambier-",
    participio_options: ["cambiuto", "cambiito", "cambioto"], futuro_options: ["cambiar-", "cambiir-", "cambir-"]},
  { verbo: "Capire", translation: "to understand", participio: "capito", futuro: "capir-",
    participio_options: ["caputo", "capato", "capeto"],
    futuro_options: ["capar-", "capier-", "capr-"]},
  { verbo: ["Camminare", "Passeggiare"], translation: "to walk", participio: "camminato", futuro: "camminer-",
    participio_options: ["camminuto", "camminito", "cammineto"], futuro_options: ["camminar-", "camminir-", "camminr-"]},
  { verbo: "Cantare", translation: "to sing", participio: "cantato", futuro: "canter-",
    participio_options: ["cantuto", "cantito", "canteto"], futuro_options: ["cantar-", "cantir-", "cantr-"]},
  { verbo: "Celebrare", translation: "to celebrate", participio: "celebrato", futuro: "celebrer-",
    participio_options: ["celebruto", "celebrito", "celebreto"], futuro_options: ["celebrar-", "celebrir-", "celebrr-"]},
  { verbo: "Cenare", translation: "to have dinner", participio: "cenato", futuro: "cener-",
    participio_options: ["cenuto", "cenito", "ceneto"],
    futuro_options: ["cenar-", "cenir-", "cenr-"]},
  { verbo: "Cercare", translation: "to look for/to search/to try", participio: "cercato", futuro: "cercher-",
    participio_options: ["cercuto", "cercito", "cercoto"], futuro_options: ["cercar-", "cerchir-", "cercr-"]},
  { verbo: "Chiamare", translation: "to call", participio: "chiamato", futuro: "chiamer-",
    participio_options: ["chiamuto", "chiamito", "chiameto"], futuro_options: ["chiamar-", "chiamir-", "chiamr-"]},
  { verbo: "Chiacchierare", translation: "to chat", participio: "chiacchierato", futuro: "chiacchierer-",
    participio_options: ["chiacchieruto", "chiacchierito", "chiacchieroto"], futuro_options: ["chiacchierar-", "chiacchierir-", "chiacchierr-"]},
  { verbo: "Chiedere", translation: "to ask", participio: "chiesto", futuro: "chieder-",
    participio_irregolare: true,
    participio_options: ["chieduto", "chiedato", "chiedito"],
    futuro_options: ["chiedr-", "chiedir-", "chiedier-"]},
  { verbo: "Chiudere", translation: "to close", participio: "chiuso", futuro: "chiuder-",
    participio_irregolare: true,
    participio_options: ["chiuduto", "chiudato", "chiudito"],
    futuro_options: ["chiudr-", "chiudir-", "chiudier-"]},
  { verbo: "Cominciare", translation: "to start", participio: "cominciato", futuro: "comincer-",
    participio_options: ["cominciuto", "cominciito", "cominceto"], futuro_options: ["cominciar-", "cominciir-", "comincir-"]},
  { verbo: "Comprare", translation: "to buy", participio: "comprato", futuro: "comprer-",
    participio_options: ["compruto", "comprito", "compreto"],
    futuro_options: ["comprar-", "comprir-", "comprr-"]},
  { verbo: "Condividere", translation: "to share", participio: "condiviso", futuro: "condivider-",
    participio_irregolare: true,
    participio_options: ["condividuto", "condividato", "condividito"],
    futuro_options: ["condividr-", "condividir-", "condividier-"]},
  { verbo: "Conoscere", translation: "to know", participio: "conosciuto", futuro: "conoscer-",
    participio_irregolare: true,
    participio_options: ["conocuto", "conoscato", "conoscito"],
    futuro_options: ["conoscer-", "conoscir-", "conocer-"]},
  { verbo: "Consegnare", translation: "to deliver", participio: "consegnato", futuro: "consegner-",
    participio_options: ["consegnuto", "consegnito", "consegnoto"], futuro_options: ["consegnar-", "consegnir-", "consegnr-"]},
  { verbo: "Consigliare", translation: "to suggest/to recommend", participio: "consigliato", futuro: "consiglier-",
    participio_options: ["consigliuto", "consigliito", "consiglieto"], futuro_options: ["consigliar-", "consigliir-", "consiglir-"]},
  { verbo: "Controllare", translation: "to check", participio: "controllato", futuro: "controller-",
    participio_options: ["controlluto", "controllito", "controlleto"], futuro_options: ["controlar-", "controllar-", "controllr-"]},
  { verbo: "Convincere", translation: "to convince", participio: "convinto", futuro: "convincer-",
    participio_irregolare: true,
    participio_options: ["convincuto", "convincato", "convincito"],
    futuro_options: ["convincr-", "convincir-", "convincier-"]},
  { verbo: "Correggere", translation: "to correct", participio: "corretto", futuro: "corregger-",
    participio_irregolare: true,
    participio_options: ["corregguto", "correggato", "correggito"],
    futuro_options: ["correggr-", "correggir-", "correggier-"]},
  { verbo: "Correre", translation: "to run", participio: "corso", futuro: "correr-",
    participio_irregolare: true,
    participio_options: ["corruto", "corrato", "corrito"],
    futuro_options: ["corrr-", "corrir-", "corrier-"]},
  { verbo: "Costare", translation: "to cost", participio: "costato", futuro: "coster-",
    participio_options: ["costuto", "costito", "costeto"], futuro_options: ["costar-", "costir-", "costr-"]},
  { verbo: "Costruire", translation: "to build", participio: "costruito", futuro: "costruir-",
    participio_options: ["costruto", "costruato", "costrueto"], futuro_options: ["costruar-", "costruer-", "costrurr-"]},
  { verbo: "Credere", translation: "to believe", participio: "creduto", futuro: "creder-",
    participio_options: ["credato", "credito", "credeto"], futuro_options: ["credr-", "credir-", "credier-"]},
  { verbo: "Cucinare", translation: "to cook", participio: "cucinato", futuro: "cuciner-",
    participio_options: ["cucinuto", "cucinito", "cucineto"],
    futuro_options: ["cucinar-", "cucinir-", "cucinr-"]},

  // D
  { verbo: "Dare", translation: "to give", participio: "dato", futuro: "dar-",
    futuro_irregolare: true,
    participio_options: ["duto", "dito", "davato"],
    futuro_options: ["daver-", "darer-", "darr-"]},
  { verbo: "Decidere", translation: "to decide", participio: "deciso", futuro: "decider-",
    participio_irregolare: true,
    participio_options: ["deciduto", "decidato", "decidito"],
    futuro_options: ["decidr-", "decidir-", "decidier-"]},
  { verbo: "Dimenticare", translation: "to forget", participio: "dimenticato", futuro: "dimenticher-",
    participio_options: ["dimenticuto", "dimenticito", "dimenticheto"],
    futuro_options: ["dimenticar-", "dimentichir-", "dimenticher-"]},
  { verbo: ["Dipingere", "Imbiancare"], translation: "to paint", participio: "dipinto", futuro: "dipinger-",
    participio_irregolare: true,
    participio_options: ["dipinguto", "dipingato", "dipingito"],
    futuro_options: ["dipingr-", "dipingir-", "dipingier-"]},
  { verbo: "Dire", translation: "to say", participio: "detto", futuro: "dir-",
    participio_irregolare: true, futuro_irregolare: true,
    participio_options: ["dirito", "dirato", "dito"],
    futuro_options: ["dicer-", "dire-", "dirr-"]},
  { verbo: "Disegnare", translation: "to draw", participio: "disegnato", futuro: "disegner-",
    participio_options: ["disegnuto", "disegnito", "disegneto"], futuro_options: ["disegnar-", "disegnir-", "disegnr-"]},
  { verbo: "Diventare", translation: "to become", participio: "diventato", futuro: "diventer-",
    participio_options: ["diventuto", "diventito", "diventeto"], futuro_options: ["diventar-", "diventir-", "diventr-"]},
  { verbo: "Divertirsi", translation: "to have fun", participio: "divertito", futuro: "divertir-",
    participio_options: ["divertuto", "divertato", "diverteto"], futuro_options: ["divertar-", "divertier-", "divertr-"]},
  { verbo: "Dormire", translation: "to sleep", participio: "dormito", futuro: "dormir-",
    participio_options: ["dormuto", "dormato", "dormeto"],
    futuro_options: ["dormar-", "dormier-", "dormr-"]},
  { verbo: "Domandare", translation: "to ask", participio: "domandato", futuro: "domander-",
    participio_options: ["domanduto", "domandito", "domandeto"], futuro_options: ["domandar-", "domandir-", "domandr-"]},
  { verbo: "Dovere", translation: "must", participio: "dovuto", futuro: "dovr-",
    futuro_irregolare: true,
    participio_options: ["dovato", "dovito", "doveto"],
    futuro_options: ["dover-", "dovrr-", "doverr-"]},
  { verbo: "Durare", translation: "to last", participio: "durato", futuro: "durer-",
    participio_options: ["duruto", "durito", "dureto"], futuro_options: ["durar-", "durir-", "durr-"]},

  // E / F / G
  { verbo: "Entrare", translation: "to go in", participio: "entrato", futuro: "entrer-",
    participio_options: ["entruto", "entrito", "entreto"],
    futuro_options: ["entrar-", "entrir-", "entrr-"]},
  { verbo: "Essere", translation: "to be", participio: "stato", futuro: "sar-",
    participio_irregolare: true, futuro_irregolare: true,
    participio_options: ["essuto", "essto", "esso"],
    futuro_options: ["esser-", "èr-", "estar-"]},
  { verbo: "Fare", translation: "to do/to make", participio: "fatto", futuro: "far-",
    participio_irregolare: true, futuro_irregolare: true,
    participio_options: ["fato", "facuto", "farito"],
    futuro_options: ["facer-", "farr-", "fazar-"]},
  { verbo: "Farsi male", translation: "to hurt oneself", participio: "fatto male", futuro: "far- male",
    participio_options: ["fato male", "facuto male", "farito male"], futuro_options: ["facer- male", "farr- male", "fazar- male"]},
  { verbo: "Fermare", translation: "to stop", participio: "fermato", futuro: "fermer-",
    participio_options: ["fermuto", "fermito", "fermeto"], futuro_options: ["fermar-", "fermir-", "fermr-"]},
  { verbo: "Finire", translation: "to finish", participio: "finito", futuro: "finir-",
    participio_options: ["finuto", "finato", "fineto"],
    futuro_options: ["finar-", "finier-", "finr-"]},
  { verbo: "Frequentare", translation: "to attend", participio: "frequentato", futuro: "frequenter-",
    participio_options: ["frequentuto", "frequentito", "frequenso"], futuro_options: ["frequentar-", "frequentir-", "frequentr-"]},
  { verbo: "Funzionare", translation: "to work (objects)", participio: "funzionato", futuro: "funzioner-",
    participio_options: ["funzionuto", "funzionito", "funzionando"], futuro_options: ["funzionar-", "funzionir-", "funzionr-"]},
  { verbo: "Giocare", translation: "to play", participio: "giocato", futuro: "giocher-",
    participio_options: ["giocuto", "giocito", "giocheto"],
    futuro_options: ["giocar-", "giocir-", "giocr-"]},
  { verbo: "Giurare", translation: "to swear", participio: "giurato", futuro: "giurer-",
    participio_options: ["giuruto", "giurito", "giuroto"], futuro_options: ["giurar-", "giurir-", "giurr-"]},
  { verbo: "Gridare", translation: "to yell", participio: "gridato", futuro: "grider-",
    participio_options: ["griduto", "gridito", "gridoto"], futuro_options: ["gridar-", "gridir-", "gridr-"]},
  { verbo: "Guadagnare", translation: "to earn", participio: "guadagnato", futuro: "guadagner-",
    participio_options: ["guadagnuto", "guadagnito", "guadagnoto"], futuro_options: ["guadagnar-", "guadagnir-", "guadagnr-"]},
  { verbo: "Guardare", translation: "to watch", participio: "guardato", futuro: "guarder-",
    participio_options: ["guarduto", "guardito", "guardeto"],
    futuro_options: ["guardar-", "guardir-", "guardr-"]},
  { verbo: "Guidare", translation: "to drive", participio: "guidato", futuro: "guider-",
    participio_options: ["guiduto", "guidito", "guidoto"], futuro_options: ["guidar-", "guidir-", "guidr-"]},
  { verbo: "Girare", translation: "to turn", participio: "girato", futuro: "girer-",
    participio_options: ["giruto", "girito", "gireto"], futuro_options: ["girar-", "girir-", "girr-"]},

  // I / L / M
  { verbo: "Incontrare", translation: "to meet", participio: "incontrato", futuro: "incontrer-",
    participio_options: ["incontruto", "incontrito", "incontreto"], futuro_options: ["incontrar-", "incontrir-", "incontrr-"]},
  { verbo: "Incominciare", translation: "to start", participio: "incominciato", futuro: "incomincer-",
    participio_options: ["incomincuto", "incomincito", "incominceto"], futuro_options: ["incomincar-", "incomincir-", "incomincr-"]},
  { verbo: "Indossare", translation: "to wear", participio: "indossato", futuro: "indosser-",
    participio_options: ["indossuto", "indossito", "indossando"], futuro_options: ["indossar-", "indossir-", "indossr-"]},
  { verbo: "Iniziare", translation: "to start", participio: "iniziato", futuro: "inizier-",
    participio_options: ["iniziuto", "iniziito", "inizieto"], futuro_options: ["iniziar-", "iniziir-", "inizir-"]},
  { verbo: "Insegnare", translation: "to teach", participio: "insegnato", futuro: "insegner-",
    participio_options: ["insegnuto", "insegnito", "insegnoto"],
    futuro_options: ["insegnar-", "insegnir-", "insegnr-"]},
  { verbo: "Immaginare", translation: "to imagine", participio: "immaginato", futuro: "immaginer-",
    participio_options: ["immaginuto", "immaginito", "immagineto"], futuro_options: ["immaginar-", "immaginir-", "immaginr-"]},
  { verbo: "Imparare", translation: "to learn", participio: "imparato", futuro: "imparer-",
    participio_options: ["imparuto", "imparito", "imparoto"],
    futuro_options: ["imparar-", "imparir-", "imparr-"]},
  { verbo: "Innamorarsi", translation: "to fall in love", participio: "innamorato", futuro: "innamorer-",
    participio_options: ["innamoruto", "innamorito", "innamoroto"], futuro_options: ["innamorar-", "innamorir-", "innamorr-"]},
  { verbo: "Lamentarsi", translation: "to complain", participio: "lamentato", futuro: "lamenter-",
    participio_options: ["lamentuto", "lamentito", "lamentoto"], futuro_options: ["lamentar-", "lamentir-", "lamentr-"]},
  { verbo: "Lavare", translation: "to wash", participio: "lavato", futuro: "laver-",
    participio_options: ["lavuto", "lavito", "laveto"], futuro_options: ["lavar-", "lavir-", "lavr-"]},
  { verbo: "Lavorare", translation: "to work", participio: "lavorato", futuro: "lavorer-",
    participio_options: ["lavoruto", "lavorito", "lavoroto"],
    futuro_options: ["lavorar-", "lavorir-", "lavorr-"]},
  { verbo: "Lasciare", translation: "to leave/to let", participio: "lasciato", futuro: "lascer-",
    participio_options: ["lasciuto", "lasciito", "lascieto"],
    futuro_options: ["lasciar-", "lasciir-", "lascir-"]},
  { verbo: "Leggere", translation: "to read", participio: "letto", futuro: "legger-",
    participio_irregolare: true,
    participio_options: ["legguto", "leggato", "leggito"],
    futuro_options: ["leggr-", "leggir-", "leggier-"]},
  { verbo: ["Litigare", "Lottare", "Combattere"], translation: "to fight", participio: "litigato", futuro: "litigher-",
    participio_options: ["litiguto", "litigito", "litighito"], futuro_options: ["litigar-", "litigir-", "litigr-"]},
  { verbo: "Mancare", translation: "to miss", participio: "mancato", futuro: "mancher-",
    participio_options: ["mancuto", "mancito", "manchito"], futuro_options: ["mancar-", "manchir-", "mancr-"]},
  { verbo: "Mandare", translation: "to send", participio: "mandato", futuro: "mander-",
    participio_options: ["manduto", "mandito", "mandoto"], futuro_options: ["mandar-", "mandir-", "mandr-"]},
  { verbo: "Mangiare", translation: "to eat", participio: "mangiato", futuro: "manger-",
    participio_options: ["mangiuto", "mangiito", "mangioto"],
    futuro_options: ["mangiar-", "mangiir-", "mangir-"]},
  { verbo: "Mantenere", translation: "to keep", participio: "mantenuto", futuro: "manterr-",
    futuro_irregolare: true,
    participio_options: ["mantenato", "mantenito", "mantenoto"],
    futuro_options: ["mantener-", "mantenier-", "mantenr-"]},
  { verbo: "Meritare", translation: "to deserve", participio: "meritato", futuro: "meriter-",
    participio_options: ["merituto", "meritito", "meritoto"], futuro_options: ["meritar-", "meritir-", "meritr-"]},
  { verbo: "Mettere", translation: "to put", participio: "messo", futuro: "metter-",
    participio_irregolare: true,
    participio_options: ["mettuto", "mettato", "mettito"],
    futuro_options: ["mettr-", "mettir-", "mettier-"]},
  { verbo: "Migliorare", translation: "to improve", participio: "migliorato", futuro: "migliorer-",
    participio_options: ["miglioruto", "migliorito", "miglioriuto"], futuro_options: ["migliorar-", "migliorir-", "migliorr-"]},
  { verbo: "Morire", translation: "to die", participio: "morto", futuro: "morir-",
    participio_irregolare: true,
    participio_options: ["moruto", "morito", "morato"],
    futuro_options: ["morr-", "morier-", "morirr-"]},
  { verbo: "Mostrare", translation: "to show", participio: "mostrato", futuro: "mostrer-",
    participio_options: ["mostruto", "mostrito", "mostroto"], futuro_options: ["mostrar-", "mostrir-", "mostrr-"]},

  // N / O / P
  { verbo: "Nascere", translation: "to be born", participio: "nato", futuro: "nascer-",
    participio_irregolare: true,
    participio_options: ["nascuto", "nascato", "nascito"],
    futuro_options: ["nascr-", "nascir-", "nascier-"]},
  { verbo: "Nascondere", translation: "to hide", participio: "nascosto", futuro: "nasconder-",
    participio_irregolare: true,
    participio_options: ["nasconduto", "nascondato", "nascondito"],
    futuro_options: ["nascondr-", "nascondir-", "nascondier-"]},
  { verbo: "Nevicare", translation: "to snow", participio: "nevicato", futuro: "nevicher-",
    participio_options: ["nevicuto", "nevicito", "nevicoto"], futuro_options: ["nevicar-", "nevichir-", "nevicr-"]},
  { verbo: "Noleggiare", translation: "to rent a vehicle", participio: "noleggiato", futuro: "nolegger-",
    participio_options: ["noleggiuto", "noleggiito", "noleggioto"], futuro_options: ["noleggiar-", "noleggiir-", "noleggir-"]},
  { verbo: "Nuotare", translation: "to swim", participio: "nuotato", futuro: "nuoter-",
    participio_options: ["nuotuto", "nuotito", "nuoto"], futuro_options: ["nuotar-", "nuotir-", "nuotr-"]},
  { verbo: "Odiare", translation: "to hate", participio: "odiato", futuro: "odier-",
    participio_options: ["odiuto", "odiito", "odianto"],
    futuro_options: ["odiar-", "odiir-", "odir-"]},
  { verbo: "Ordinare", translation: "to order", participio: "ordinato", futuro: "ordiner-",
    participio_options: ["ordinuto", "ordinito", "ordineto"], futuro_options: ["ordinar-", "ordinir-", "ordinr-"]},
  { verbo: "Organizzare", translation: "to organize", participio: "organizzato", futuro: "organizzer-",
    participio_options: ["organizzuto", "organizzito", "organizzeto"], futuro_options: ["organizzar-", "organizzir-", "organizzr-"]},
  { verbo: "Offendere", translation: "to offend", participio: "offeso", futuro: "offender-",
    participio_irregolare: true,
    participio_options: ["offenduto", "offendato", "offendito"],
    futuro_options: ["offendr-", "offendir-", "offendier-"]},
  { verbo: "Offrire", translation: "to offer", participio: "offerto", futuro: "offrir-",
    participio_irregolare: true,
    participio_options: ["offruto", "offrito", "offrato"],
    futuro_options: ["offrr-", "offrier-", "offrirr-"]},
  { verbo: "Ospitare", translation: "to host", participio: "ospitato", futuro: "ospiter-",
    participio_options: ["ospituto", "ospitito", "ospiteto"], futuro_options: ["ospitar-", "ospitir-", "ositr-"]},
  { verbo: "Ottenere", translation: "to obtain", participio: "ottenuto", futuro: "otterr-",
    futuro_irregolare: true,
    participio_options: ["ottenato", "ottenito", "ottenoto"],
    futuro_options: ["ottener-", "ottenier-", "ottenr-"]},
  { verbo: "Pagare", translation: "to pay", participio: "pagato", futuro: "pagher-",
    participio_options: ["paguto", "pagito", "paghito"],
    futuro_options: ["pagar-", "paghir-", "pagr-"]},
  { verbo: "Parcheggiare", translation: "to park", participio: "parcheggiato", futuro: "parchegger-",
    participio_options: ["parcheggiuto", "parcheggito", "parcheggioto"], futuro_options: ["parcheggiar-", "parcheggiir-", "parchegger-"]},
  { verbo: "Parlare", translation: "to speak", participio: "parlato", futuro: "parler-",
    participio_options: ["parluto", "parlito", "parleto"],
    futuro_options: ["parlar-", "parlir-", "parlr-"]},
  { verbo: "Partecipare", translation: "to attend/to participate", participio: "partecipato", futuro: "parteciper-",
    participio_options: ["parteciputo", "partecipito", "partecipando"], futuro_options: ["partecipar-", "partecipir-", "parteciper-"]},
  { verbo: "Partire", translation: "to leave for a trip", participio: "partito", futuro: "partir-",
    participio_options: ["partuto", "partato", "parteto"],
    futuro_options: ["partar-", "partier-", "partr-"]},
  { verbo: "Passare", translation: "to pass/to spend (time)", participio: "passato", futuro: "passer-",
    participio_options: ["passuto", "passito", "passinto"], futuro_options: ["passar-", "passir-", "passr-"]},
  { verbo: ["Passeggiare", "Camminare"], translation: "to walk", participio: "passeggiato", futuro: "passegger-",
    participio_options: ["passegguto", "passeggiuto", "passeggito"], futuro_options: ["passeggiar-", "passeggiir-", "passegger-"]},
  { verbo: "Pensare", translation: "to think", participio: "pensato", futuro: "penser-",
    participio_options: ["pensuto", "pensito", "penseto"], futuro_options: ["pensar-", "pensir-", "pensr-"]},
  { verbo: "Perdere", translation: "to lose", participio: "perso", futuro: "perder-",
    participio_irregolare: true,
    participio_options: ["perduto", "perdato", "perdito"],
    futuro_options: ["perdr-", "perdir-", "perdier-"]},
  { verbo: "Piacere", translation: "to like", participio: "piaciuto", futuro: "piacer-",
    participio_irregolare: true,
    participio_options: ["piacuto", "piacato", "piacito"],
    futuro_options: ["piacr-", "piacir-", "piacier-"]},
  { verbo: "Piangere", translation: "to cry", participio: "pianto", futuro: "pianger-",
    participio_irregolare: true,
    participio_options: ["pianguto", "piangato", "piangito"],
    futuro_options: ["piangr-", "piangir-", "piangier-"]},
  { verbo: "Piovere", translation: "to rain", participio: "piovuto", futuro: "piover-",
    participio_options: ["piovato", "piovito", "pioveto"], futuro_options: ["piovr-", "piovir-", "piovierr-"]},
  { verbo: "Portare", translation: "to bring", participio: "portato", futuro: "porter-",
    participio_options: ["portuto", "portito", "porteto"], futuro_options: ["portar-", "portir-", "portr-"]},
  { verbo: "Potere", translation: "can", participio: "potuto", futuro: "potr-",
    futuro_irregolare: true,
    participio_options: ["potato", "potito", "poteto"],
    futuro_options: ["poder-", "poterr-", "potrer-"]},
  { verbo: "Pranzare", translation: "to have lunch", participio: "pranzato", futuro: "pranzer-",
    participio_options: ["pranzuto", "pranzito", "pranzeto"],
    futuro_options: ["pranzar-", "pranzir-", "pranzr-"]},
  { verbo: "Preferire", translation: "to prefer", participio: "preferito", futuro: "preferir-",
    participio_options: ["preferuto", "preferato", "prefereto"], futuro_options: ["preferar-", "preferier-", "preferr-"]},
  { verbo: "Prendere", translation: "to take/to pick up", participio: "preso", futuro: "prender-",
    participio_irregolare: true,
    participio_options: ["prenduto", "prendato", "prendito"],
    futuro_options: ["prendr-", "prendir-", "prendier-"]},
  { verbo: "Prenotare", translation: "to book", participio: "prenotato", futuro: "prenoter-",
    participio_options: ["prenotuto", "prenotito", "prenoteto"], futuro_options: ["prenotar-", "prenotir-", "prenotr-"]},
  { verbo: "Preparare", translation: "to prepare", participio: "preparato", futuro: "preparer-",
    participio_options: ["preparuto", "preparito", "prepareto"], futuro_options: ["preparar-", "preparir-", "preparr-"]},
  { verbo: "Prestare", translation: "to lend", participio: "prestato", futuro: "prester-",
    participio_options: ["prestuto", "prestito", "presteto"], futuro_options: ["prestar-", "prestir-", "prestr-"]},
  { verbo: "Proibire", translation: "to prohibit", participio: "proibito", futuro: "proibir-",
    participio_options: ["proibuto", "proibato", "proibeto"], futuro_options: ["proibar-", "proibier-", "proibrr-"]},
  { verbo: "Promettere", translation: "to promise", participio: "promesso", futuro: "prometter-",
    participio_irregolare: true,
    participio_options: ["promettuto", "promettato", "promettito"],
    futuro_options: ["promettr-", "promettir-", "promettier-"]},
  { verbo: "Proporre", translation: "to propose", participio: "proposto", futuro: "proporr-",
    participio_irregolare: true, futuro_irregolare: true,
    participio_options: ["proponuto", "proponato", "proponito"],
    futuro_options: ["proponer-", "proponr-", "proporn-"]},
  { verbo: "Provare", translation: "to try", participio: "provato", futuro: "prover-",
    participio_options: ["provuto", "provito", "proveto"], futuro_options: ["provar-", "provir-", "provr-"]},
  { verbo: "Pulire", translation: "to clean", participio: "pulito", futuro: "pulir-",
    participio_options: ["puluto", "pulato", "puleto"], futuro_options: ["pular-", "pulier-", "pulirr-"]},

  // R
  { verbo: "Raccogliere", translation: "to pick up/to harvest", participio: "raccolto", futuro: "raccoglier-",
    participio_irregolare: true,
    participio_options: ["raccogliuto", "raccogliato", "raccogliito"],
    futuro_options: ["raccoglr-", "raccoglir-", "raccoglierr-"]},
  { verbo: "Regalare", translation: "to gift", participio: "regalato", futuro: "regaler-",
    participio_options: ["regaluto", "regalito", "regaleto"], futuro_options: ["regalar-", "regalir-", "regalr-"]},
  { verbo: "Registrare", translation: "to record", participio: "registrato", futuro: "registrer-",
    participio_options: ["registruto", "registrito", "registreto"], futuro_options: ["registrar-", "registrir-", "registrr-"]},
  { verbo: "Rendersi conto", translation: "to realize", participio: "reso conto", futuro: "render- conto",
    participio_irregolare: true,
    participio_options: ["renduto conto", "rendato conto", "rendito conto"],
    futuro_options: ["rendr- conto", "rendir- conto", "rendier- conto"]},
  { verbo: "Realizzare", translation: "to realize", participio: "realizzato", futuro: "realizzer-",
    participio_options: ["realizzuto", "realizzito", "realizzeto"], futuro_options: ["realizzar-", "realizzir-", "realizzr-"]},
  { verbo: "Respirare", translation: "to breathe", participio: "respirato", futuro: "respirer-",
    participio_options: ["respiruto", "respirito", "respireto"], futuro_options: ["respirar-", "respirir-", "respirr-"]},
  { verbo: "Restare", translation: "to stay", participio: "restato", futuro: "rester-",
    participio_options: ["restuto", "restito", "resteto"],
    futuro_options: ["restar-", "restir-", "restr-"]},
  { verbo: "Restituire", translation: "to give back", participio: "restituito", futuro: "restituir-",
    participio_options: ["restituto", "restituato", "restitueto"], futuro_options: ["restituar-", "restituier-", "restituirr-"]},
  { verbo: "Ricordare", translation: "to remember", participio: "ricordato", futuro: "ricorder-",
    participio_options: ["ricorduto", "ricordito", "ricordeto"],
    futuro_options: ["ricordar-", "ricordir-", "ricordr-"]},
  { verbo: "Ricevere", translation: "to receive", participio: "ricevuto", futuro: "ricever-",
    participio_options: ["ricevato", "ricevito", "riceveto"], futuro_options: ["ricevr-", "ricevir-", "recevier-"]},
  { verbo: "Ridere", translation: "to laugh", participio: "riso", futuro: "rider-",
    participio_irregolare: true,
    participio_options: ["riduto", "ridato", "ridito"],
    futuro_options: ["ridr-", "ridir-", "ridier-"]},
  { verbo: "Rimanere", translation: "to remain", participio: "rimasto", futuro: "rimarr-",
    participio_irregolare: true, futuro_irregolare: true,
    participio_options: ["rimanuto", "rimanato", "rimanito"],
    futuro_options: ["rimaner-", "rimanr-", "rimanerr-"]},
  { verbo: "Rinnovare", translation: "to renew", participio: "rinnovato", futuro: "rinnover-",
    participio_options: ["rinnovuto", "rinnovito", "rinnoveto"], futuro_options: ["rinnovar-", "rinnovir-", "rinnovr-"]},
  { verbo: "Ripetere", translation: "to repeat", participio: "ripetuto", futuro: "ripeter-",
    participio_options: ["ripetato", "ripetito", "ripeteto"], futuro_options: ["ripetr-", "ripetir-", "ripetier-"]},
  { verbo: "Riposare", translation: "to rest", participio: "riposato", futuro: "riposer-",
    participio_options: ["riposuto", "riposito", "riposeto"],
    futuro_options: ["riposar-", "riposir-", "riposr-"]},
  { verbo: "Risparmiare", translation: "to save money or time", participio: "risparmiato", futuro: "risparmier-",
    participio_options: ["risparmuto", "risparmito", "risparmato"], futuro_options: ["risparmiar-", "risparmier-", "risparmir-"]},
  { verbo: "Rispondere", translation: "to answer", participio: "risposto", futuro: "risponder-",
    participio_irregolare: true,
    participio_options: ["risponduto", "rispondato", "rispondito"],
    futuro_options: ["rispondr-", "rispondir-", "rispondier-"]},
  { verbo: "Ritornare", translation: "to return", participio: "ritornato", futuro: "ritorner-",
    participio_options: ["ritornuto", "ritornito", "ritorneto"], futuro_options: ["ritornar-", "ritornir-", "ritornr-"]},
  { verbo: "Riuscire", translation: "to be able to", participio: "riuscito", futuro: "riuscir-",
    participio_options: ["riuscuto", "riuscato", "riusceto"], futuro_options: ["riuscar-", "riuscier-", "riuscirr-"]},

  // S
  { verbo: "Salire", translation: "to go up", participio: "salito", futuro: "salir-",
    participio_options: ["saluto", "salato", "saleto"],
    futuro_options: ["salar-", "salier-", "salirr-"]},
  { verbo: "Salutare", translation: "to greet", participio: "salutato", futuro: "saluter-",
    participio_options: ["salututo", "salutito", "saluteto"], futuro_options: ["salutar-", "salutir-", "salutr-"]},
  { verbo: "Sapere", translation: "to know (a fact)", participio: "saputo", futuro: "sapr-",
    futuro_irregolare: true,
    participio_options: ["sapato", "sapito", "sapeto"],
    futuro_options: ["saper-", "saperr-", "saprr-"]},
  { verbo: "Sbadigliare", translation: "to yawn", participio: "sbadigliato", futuro: "sbadiglier-",
    participio_options: ["sbadigliuto", "sbadigliito", "sbadiglieto"], futuro_options: ["sbadigliar-", "sbadigliir-", "sbadiglir-"]},
  { verbo: "Sbagliare", translation: "to make a mistake", participio: "sbagliato", futuro: "sbaglier-",
    participio_options: ["sbagliuto", "sbagliito", "sbaglieto"], futuro_options: ["sbagliar-", "sbagliir-", "sbaglir-"]},
  { verbo: "Sbocciare", translation: "to bloom", participio: "sbocciato", futuro: "sboccer-",
    participio_options: ["sbocciuto", "sbocciito", "sboccato"], futuro_options: ["sbocciar-", "sbocciir-", "sboccir-"]},
  { verbo: "Scegliere", translation: "to choose", participio: "scelto", futuro: "sceglier-",
    participio_irregolare: true,
    participio_options: ["scegliuto", "scegliato", "scegliito"],
    futuro_options: ["sceglr-", "sceglir-", "scegliierr-"]},
  { verbo: "Scendere", translation: "to go down", participio: "sceso", futuro: "scender-",
    participio_irregolare: true,
    participio_options: ["scenduto", "scendato", "scendito"],
    futuro_options: ["scendr-", "scendir-", "scendier-"]},
  { verbo: "Sciare", translation: "to ski", participio: "sciato", futuro: "scier-",
    participio_options: ["sciuto", "sciito", "scieto"], futuro_options: ["sciar-", "sciir-", "scir-"]},
  { verbo: "Sciogliere", translation: "to melt", participio: "sciolto", futuro: "scioglier-",
    participio_irregolare: true,
    participio_options: ["sciogliuto", "sciogliato", "sciogliito"],
    futuro_options: ["scioglr-", "scioglir-", "scioglierr-"]},
  { verbo: "Scomparire", translation: "to disappear", participio: "scomparso", futuro: "scomparir-",
    participio_irregolare: true,
    participio_options: ["scomparuto", "scomparato", "scomparito"],
    futuro_options: ["scomparr-", "scomparer-", "scomparier-"]},
  { verbo: "Scoprire", translation: "to discover", participio: "scoperto", futuro: "scoprir-",
    participio_irregolare: true,
    participio_options: ["scopruto", "scoprito", "scoprato"],
    futuro_options: ["scoprr-", "scoprer-", "scoprier-"]},
  { verbo: "Scrivere", translation: "to write", participio: "scritto", futuro: "scriver-",
    participio_irregolare: true,
    participio_options: ["scrivuto", "scrivato", "scrivito"],
    futuro_options: ["scrivr-", "scrivir-", "scrivier-"]},
  { verbo: "Scusare", translation: "to excuse", participio: "scusato", futuro: "scuser-",
    participio_options: ["scusuto", "scusito", "scuseto"], futuro_options: ["scusar-", "scusir-", "scusr-"]},
  { verbo: "Sedersi", translation: "to sit down", participio: "seduto", futuro: "sieder-",
    participio_irregolare: true,
    participio_options: ["sedato", "sedito", "sedeto"],
    futuro_options: ["sedr-", "sedir-", "sedier-"]},
  { verbo: "Sembrare", translation: "to look like/to seem", participio: "sembrato", futuro: "sembrer-",
    participio_options: ["sembruto", "sembrito", "sembreto"], futuro_options: ["sembrar-", "sembrir-", "sembrr-"]},
  { verbo: "Sentire", translation: "to hear/to feel", participio: "sentito", futuro: "sentir-",
    participio_options: ["sentuto", "sentato", "senteto"],
    futuro_options: ["sentar-", "sentier-", "sentr-"]},
  { verbo: "Smettere", translation: "to stop", participio: "smesso", futuro: "smetter-",
    participio_irregolare: true,
    participio_options: ["smettuto", "smettato", "smettito"],
    futuro_options: ["smettr-", "smettir-", "smettier-"]},
  { verbo: "Sognare", translation: "to dream", participio: "sognato", futuro: "sogner-",
    participio_options: ["sognuto", "sognito", "sogneto"], futuro_options: ["sognar-", "sognir-", "sognr-"]},
  { verbo: "Sollevare", translation: "to lift", participio: "sollevato", futuro: "sollever-",
    participio_options: ["sollevuto", "sollevito", "solleveto"], futuro_options: ["sollevar-", "sollevir-", "sollevr-"]},
  { verbo: "Spedire", translation: "to send", participio: "spedito", futuro: "spedir-",
    participio_options: ["speduto", "spedato", "spedeto"], futuro_options: ["spedar-", "spedier-", "spedirr-"]},
  { verbo: "Spegnere", translation: "to turn off", participio: "spento", futuro: "spegner-",
    participio_irregolare: true,
    participio_options: ["spegnuto", "spegnato", "spegnito"],
    futuro_options: ["spegnr-", "spegnir-", "spegnier-"]},
  { verbo: "Spendere", translation: "to spend", participio: "speso", futuro: "spender-",
    participio_irregolare: true,
    participio_options: ["spenduto", "spendato", "spendito"],
    futuro_options: ["spendr-", "spendir-", "spendier-"]},
  { verbo: "Sperare", translation: "to hope", participio: "sperato", futuro: "sperer-",
    participio_options: ["speruto", "sperito", "spereto"], futuro_options: ["sperar-", "sperir-", "sperr-"]},
  { verbo: "Spiegare", translation: "to explain", participio: "spiegato", futuro: "spiegher-",
    participio_options: ["spieguto", "spiegito", "spieghato"], futuro_options: ["spiegar-", "spieghir-", "spiegr-"]},
  { verbo: "Sposare", translation: "to marry", participio: "sposato", futuro: "sposer-",
    participio_options: ["sposuto", "sposito", "sposeto"], futuro_options: ["sposar-", "sposir-", "sposr-"]},
  { verbo: "Squillare", translation: "to ring", participio: "squillato", futuro: "squiller-",
    participio_options: ["squilluto", "squillito", "squilleto"], futuro_options: ["squillar-", "squillir-", "squillr-"]},
  { verbo: "Stampare", translation: "to print", participio: "stampato", futuro: "stamper-",
    participio_options: ["stamputo", "stampito", "stampeto"], futuro_options: ["stampar-", "stampir-", "stampr-"]},
  { verbo: "Stancarsi", translation: "to get tired", participio: "stancato", futuro: "stancher-",
    participio_options: ["stancuto", "stancito", "stanchato"], futuro_options: ["stancar-", "stanchir-", "stancr-"]},
  { verbo: "Stare", translation: "to be/to stay", participio: "stato", futuro: "star-",
    participio_irregolare: true,
    participio_options: ["stasto", "strito", "stuto"],
    futuro_options: ["staver-", "starer-", "starr-"]},
  { verbo: "Stirare", translation: "to iron", participio: "stirato", futuro: "stirer-",
    participio_options: ["stiruto", "stirito", "stireto"], futuro_options: ["stirar-", "stirir-", "stirr-"]},
  { verbo: "Studiare", translation: "to study", participio: "studiato", futuro: "studier-",
    participio_options: ["studiuto", "studiito", "studieto"],
    futuro_options: ["studiar-", "studiir-", "studir-"]},
  { verbo: "Succedere", translation: "to happen", participio: "successo", futuro: "succeder-",
    participio_irregolare: true,
    participio_options: ["succeduto", "succedato", "succedito"],
    futuro_options: ["succedr-", "succedir-", "succedier-"]},
  { verbo: "Suonare", translation: "to play an instrument", participio: "suonato", futuro: "suoner-",
    participio_options: ["suonuto", "suonito", "suoneto"],
    futuro_options: ["suonar-", "suonir-", "suonr-"]},
  { verbo: "Svegliare", translation: "to wake up", participio: "svegliato", futuro: "sveglier-",
    participio_options: ["svegliuto", "svegliito", "sveglieto"],
    futuro_options: ["svegliar-", "svegliir-", "sveglir-"]},
  { verbo: "Svenire", translation: "to faint", participio: "svenuto", futuro: "svenir-",
    participio_irregolare: true,
    participio_options: ["svenato", "svenito", "svento"],
    futuro_options: ["svenr-", "svener-", "svenirr-"]},

  // T / U / V / Z
  { verbo: "Tagliare", translation: "to cut", participio: "tagliato", futuro: "taglier-",
    participio_options: ["tagliuto", "tagliito", "taglieto"], futuro_options: ["tagliar-", "tagliir-", "taglir-"]},
  { verbo: "Telefonare", translation: "to call someone (phone)", participio: "telefonato", futuro: "telefoner-",
    participio_options: ["telefonuto", "telefonito", "telefoneto"], futuro_options: ["telefonar-", "telefonir-", "telefonr-"]},
  { verbo: "Togliere", translation: "to take off", participio: "tolto", futuro: "toglier-",
    participio_irregolare: true,
    participio_options: ["togliuto", "togliato", "togliito"],
    futuro_options: ["toglr-", "toglir-", "togliierr-"]},
  { verbo: "Tornare", translation: "to go back", participio: "tornato", futuro: "torner-",
    participio_options: ["tornuto", "tornito", "torneto"],
    futuro_options: ["tornar-", "tornir-", "tornr-"]},
  { verbo: "Trasferirsi", translation: "to move", participio: "trasferito", futuro: "trasferir-",
    participio_options: ["trasferuto", "trasferato", "trasfereto"], futuro_options: ["trasferar-", "trasferier-", "trasferirr-"]},
  { verbo: "Tradurre", translation: "to translate", participio: "tradotto", futuro: "tradurr-",
    participio_irregolare: true, futuro_irregolare: true,
    participio_options: ["traduto", "tradurito", "traduato"],
    futuro_options: ["traducer-", "tradurre-", "tradur-"]},
  { verbo: "Trovare", translation: "to find/to visit (a person)", participio: "trovato", futuro: "trover-",
    participio_options: ["trovuto", "trovito", "troveto"],
    futuro_options: ["trovar-", "trovir-", "trovr-"]},
  { verbo: "Trovarsi", translation: "to be placed", participio: "trovato", futuro: "trover-",
    participio_options: ["trovuto", "trovito", "trovandosi"], futuro_options: ["trovarsi-", "trovir-", "trovr-"]},
  { verbo: "Truccarsi", translation: "to put makeup on", participio: "truccato", futuro: "truccher-",
    participio_options: ["truccuto", "truccito", "truccheto"], futuro_options: ["truccar-", "trucchir-", "truccr-"]},
  { verbo: ["Unire", "Combinare"], translation: "to combine", participio: "unito", futuro: "unir-",
    participio_options: ["unuto", "unato", "uneto"], futuro_options: ["unar-", "unier-", "unirr-"]},
  { verbo: "Urlare", translation: "to yell", participio: "urlato", futuro: "urler-",
    participio_options: ["urluto", "urlito", "urleto"], futuro_options: ["urlar-", "urlir-", "urlr-"]},
  { verbo: "Usare", translation: "to use", participio: "usato", futuro: "user-",
    participio_options: ["usuto", "usito", "useto"], futuro_options: ["usar-", "usir-", "usr-"]},
  { verbo: "Uscire", translation: "to go out", participio: "uscito", futuro: "uscir-",
    participio_options: ["uscuto", "uscato", "usceto"],
    futuro_options: ["uscar-", "uscier-", "uscirr-"]},
  { verbo: "Vedere", translation: "to see", participio: "visto", futuro: "vedr-",
    participio_irregolare: true, futuro_irregolare: true,
    participio_options: ["veduto", "vedato", "vedito"],
    futuro_options: ["veder-", "vederr-", "vedrer-"]},
  { verbo: "Vendere", translation: "to sell", participio: "venduto", futuro: "vender-",
    participio_options: ["vendato", "vendito", "vendeto"],
    futuro_options: ["vendr-", "vendir-", "vendier-"]},
  { verbo: "Venire", translation: "to come", participio: "venuto", futuro: "verr-",
    futuro_irregolare: true,
    participio_options: ["venato", "venito", "veneto"],
    futuro_options: ["venir-", "venirr-", "venr-"]},
  { verbo: "Vestirsi", translation: "to get dressed", participio: "vestito", futuro: "vestir-",
    participio_options: ["vestuto", "vestato", "vesteto"], futuro_options: ["vestar-", "vestier-", "vestirr-"]},
  { verbo: "Viaggiare", translation: "to travel", participio: "viaggiato", futuro: "viagger-",
    participio_options: ["viaggiuto", "viaggiito", "viaggieto"], futuro_options: ["viaggiar-", "viaggiir-", "viaggir-"]},
  { verbo: "Vincere", translation: "to win", participio: "vinto", futuro: "vincer-",
    participio_irregolare: true,
    participio_options: ["vincuto", "vincato", "vincito"],
    futuro_options: ["vincr-", "vincir-", "vincier-"]},
  { verbo: "Visitare", translation: "to visit", participio: "visitato", futuro: "visiter-",
    participio_options: ["visituto", "visitito", "visiteto"], futuro_options: ["visitar-", "visitir-", "visitr-"]},
  { verbo: "Vivere", translation: "to live", participio: "vissuto", futuro: "vivr-",
    participio_irregolare: true, futuro_irregolare: true,
    participio_options: ["vivuto", "vivato", "vivito"],
    futuro_options: ["viver-", "viverr-", "vivir-"]},
  { verbo: "Volare", translation: "to fly", participio: "volato", futuro: "voler-",
    participio_options: ["voluto", "volito", "voleto"], futuro_options: ["volar-", "volir-", "volr-"]},
  { verbo: "Volere", translation: "to want", participio: "voluto", futuro: "vorr-",
    futuro_irregolare: true,
    participio_options: ["volato", "volito", "voleto"],
    futuro_options: ["voler-", "volerr-", "volr-"]},
];